var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getUrls } from '@shared/utils/config/environment';
import { useLocalStorage } from 'usehooks-ts';
export function formatChartDate(date, periodLabel) {
    switch (periodLabel) {
        case '1H':
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
        case '1D':
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
        case '1W':
        case '1M':
            return date.toLocaleString('default', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        case '3M':
        case '1Y':
        case 'ALL':
            return date.toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' });
        default:
            return date.toLocaleString('default', {
                // month: 'short',
                // day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
    }
}
var _getUserWalletDataByTimeframe = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var ethData, solData, error_1, error_2;
    var ethWallet = _b.ethWallet, solanaWallet = _b.solanaWallet, currentResolution = _b.currentResolution;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat(getUrls().INDEXER_URL, "/portfolio?wallet=").concat(ethWallet, "&timeFrame=").concat(currentResolution.timeFrame, "&doNotIncludeTokens=true"))];
            case 1:
                ethData = _c.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _c.sent();
                console.error('Error fetching Ethereum wallet data:', error_1);
                ethData = { data: { status: 'error', data: [] } };
                return [3 /*break*/, 3];
            case 3:
                _c.trys.push([3, 5, , 6]);
                return [4 /*yield*/, axios.get("".concat(getUrls().INDEXER_URL, "/portfolio?wallet=").concat(solanaWallet, "&timeFrame=").concat(currentResolution.timeFrame, "&doNotIncludeTokens=true"))];
            case 4:
                solData = _c.sent();
                return [3 /*break*/, 6];
            case 5:
                error_2 = _c.sent();
                console.error('Error fetching Solana wallet data:', error_2);
                solData = { data: { status: 'error', data: [] } };
                return [3 /*break*/, 6];
            case 6:
                if (ethData.data.status === 'error' && solData.data.status === 'error')
                    throw new Error('_getUserWalletDataByTimeframe:Could not fetch any data.');
                return [2 /*return*/, { ethData: ethData, solData: solData }];
        }
    });
}); };
var _getBarData = function (ethData, solData) {
    var barData = [];
    if (ethData.data.status === 'success' && solData.data.status === 'success') {
        var index1 = 0, index2 = 0, prevEthUsdValue = 0, prevSolUsdValue = 0;
        while (index1 < ethData.data.totals.length || index2 < solData.data.totals.length) {
            var ethTimeStamp = 0, ethUsdValue = prevEthUsdValue, solTimeStamp = 0, solUsdValue = prevSolUsdValue;
            if (ethData.data.totals[index1]) {
                ethTimeStamp = ethData.data.totals[index1]['unix_timestamp'];
                ethUsdValue = ethData.data.totals[index1]['total'];
                prevEthUsdValue = ethUsdValue;
            }
            if (solData.data.totals[index2]) {
                solTimeStamp = solData.data.totals[index2]['unix_timestamp'];
                solUsdValue = solData.data.totals[index2]['total'];
                prevSolUsdValue = solUsdValue;
            }
            if (ethTimeStamp == solTimeStamp) {
                barData.push({
                    value: ethUsdValue + solUsdValue,
                    time: ethTimeStamp,
                });
                index1++;
                index2++;
            }
            else if (ethTimeStamp < solTimeStamp || solTimeStamp == 0) {
                barData.push({
                    value: ethUsdValue + solUsdValue,
                    time: ethTimeStamp,
                });
                index1++;
                if (index1 > ethData.data.totals.length) {
                    break;
                }
            }
            else {
                barData.push({
                    value: ethUsdValue + solUsdValue,
                    time: solTimeStamp,
                });
                index2++;
                if (index2 > solData.data.totals.length) {
                    break;
                }
            }
        }
    }
    barData = barData
        .sort(function (a, b) { return a.time - b.time; })
        .filter(function (item, index, array) { return index === 0 || item.time !== array[index - 1].time; });
    return barData;
};
export var usePortfolioChartData = function (_a) {
    var ethWallet = _a.ethWallet, solanaWallet = _a.solanaWallet, currentResolution = _a.currentResolution;
    var _b = useLocalStorage('portfolioChartData', {}), portfolioChartDataLC = _b[0], setPortfolioChartDataLC = _b[1];
    var query = useQuery({
        queryKey: ['getPortfolioChartData', { ethWallet: ethWallet, solanaWallet: solanaWallet, currentResolution: currentResolution }],
        refetchInterval: 5000,
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _params, res, barData, newLCData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _params = {
                            ethWallet: ethWallet,
                            solanaWallet: solanaWallet,
                            currentResolution: currentResolution,
                        };
                        return [4 /*yield*/, _getUserWalletDataByTimeframe(__assign({}, _params))];
                    case 1:
                        res = _b.sent();
                        barData = (_a = _getBarData(res.ethData, res.solData)) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.time > 0; });
                        newLCData = __assign({}, portfolioChartDataLC);
                        newLCData[currentResolution.periodLabel] = barData;
                        setPortfolioChartDataLC(newLCData);
                        return [2 /*return*/, barData === null || barData === void 0 ? void 0 : barData.filter(function (item) { return item.time > 0; })];
                }
            });
        }); },
        enabled: Boolean(ethWallet || solanaWallet) && Boolean(currentResolution),
    });
    return __assign(__assign({}, query), { data: portfolioChartDataLC[currentResolution.periodLabel] || query.data, isLoading: !portfolioChartDataLC[currentResolution.periodLabel] && query.isLoading });
};
